<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p>
        Based on the diagram shown, click the buttons below to write out the
        <b>complete</b> electron configuration for the system.
      </p>
      <p>
        <img :src="ecImage" width="650" height="auto" style="max-width: 100%" />
      </p>
      <electron-configuration-input
        v-model="inputs.input1"
        :max-n="4"
        :max-occupation="10"
        :orbital-types="['s', 'p', 'd']"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ElectronConfigurationInput from '../inputs/ElectronConfigurationInput';

export default {
  name: 'Question33',
  components: {
    ElectronConfigurationInput,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking
      inputs: {input1: []},
    };
  },
  computed: {
    ecImagePos() {
      return this.taskState.getValueBySymbol('arrayVariable').content.value;
    },
    ecImage() {
      return `/img/assignments/qid33ec${this.ecImagePos}.png`;
    },
  },
};
</script>
